"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _hoisted_1 = ["onSubmit"];
var _hoisted_2 = /*#__PURE__*/ vue_2.createElementVNode("div", { class: "heading" }, "Данные организации", -1);
var _hoisted_3 = { class: "submission-form__inputs" };
var _hoisted_4 = { class: "submission-form__grid-4" };
var _hoisted_5 = { class: "submission-form__inputs" };
var _hoisted_6 = { class: "checkbox-radio" };
var _hoisted_7 = /*#__PURE__*/ vue_2.createElementVNode("div", { class: "checkbox" }, [
    /*#__PURE__*/ vue_2.createElementVNode("i", { class: "termi-circle-checkmark" })
], -1);
var _hoisted_8 = /*#__PURE__*/ vue_2.createTextVNode(" Юридический и фактический адресы отличаются ");
var _hoisted_9 = /*#__PURE__*/ vue_2.createElementVNode("div", { class: "heading" }, "Контактное лицо", -1);
var _hoisted_10 = { class: "submission-form__inputs" };
var _hoisted_11 = { class: "submission-form__grid-2" };
var _hoisted_12 = /*#__PURE__*/ vue_2.createElementVNode("div", { class: "heading" }, "Пароль", -1);
var _hoisted_13 = { class: "submission-form__grid-2" };
var _hoisted_14 = /*#__PURE__*/ vue_2.createStaticVNode("<div class=\"submission-form__bottom\"><label class=\"checkbox-radio\"><input type=\"checkbox\" name=\"personality\" checked class=\"required\"><div class=\"checkbox\"><i class=\"termi-circle-checkmark\"></i></div> Я согласен на  <a href=\"/terms/\" class=\"link\">обработку персональных данных</a></label><button type=\"submit\" class=\"default-btn submission-form__submit\">Зарегистрироваться</button></div>", 1);
var _hoisted_15 = { class: "form-errors" };
var vue_3 = require("vue");
var vuex_1 = require("vuex");
var helpers_1 = require("vue_components/helpers");
var InputContainer_vue_1 = require("vue_components/InputContainer.vue");
var Address_vue_1 = require("@/components/SubmissionForm/Address.vue");
exports.default = vue_1.defineComponent({
    emits: ['sendForm'],
    setup: function (__props, _a) {
        var emit = _a.emit;
        var store = vuex_1.useStore();
        // org
        var orgForm = vue_3.ref({
            ajax: { value: '1' },
            check_string: { value: store.state.rootProps.checkString },
            hash_string: { value: store.state.rootProps.checkStringSalt },
            person_type: { value: 'org' },
            name: {
                placeholder: 'ФИО',
                required: true,
                value: ''
            },
            phone: {
                type: 'tel',
                pattern: helpers_1.inputProperties.tel.pattern,
                placeholder: '+7 (XXX) XXX-XX-XX',
                required: true,
                value: ''
            },
            email: {
                placeholder: 'E-mail',
                pattern: helpers_1.inputProperties.email.pattern,
                type: 'email',
                required: true,
                value: ''
            },
            pass: {
                placeholder: 'Пароль',
                pattern: helpers_1.inputProperties.password.pattern,
                type: 'password',
                required: true,
                value: ''
            },
            pass2: {
                placeholder: 'Повторите пароль',
                pattern: helpers_1.inputProperties.password.pattern,
                type: 'password',
                required: true,
                value: ''
            },
            company_name: {
                required: true,
                placeholder: 'Наименование организации',
                value: '',
            },
            inn: {
                placeholder: 'ИНН',
                required: true,
                value: ''
            },
            kpp: {
                placeholder: 'КПП',
                required: true,
                value: ''
            },
            orgn: {
                placeholder: 'ОРГН',
                required: true,
                value: ''
            },
            bik: {
                placeholder: 'БИК',
                required: true,
                value: ''
            },
            r_s: {
                placeholder: 'р/с',
                required: true,
                value: ''
            },
            jur_address: {
                value: ''
            },
            fac_address: {
                value: ''
            }
        });
        var formErrors = vue_3.ref([]);
        function updateFormKey(form, _a) {
            var key = _a.key, value = _a.value;
            form[key].value = value;
        }
        var checkbox = vue_3.ref(false);
        function syncInputs(input, target) {
            vue_3.watch(function () { return input; }, function (newVal) {
                if (checkbox.value)
                    return;
                target.value = newVal.value;
            }, { deep: true });
        }
        syncInputs(orgForm.value.jur_address, orgForm.value.fac_address);
        function submitOrg() {
            formErrors.value.length = 0;
            helpers_1.validateForm(orgForm.value, formErrors.value);
            if (formErrors.value.length)
                throw new Error(formErrors.value);
            var formData = helpers_1.formToFormData(fizForm.value);
            emit('sendForm', {
                formData: formData,
                errors: formErrors.value
            });
        }
        return function (_ctx, _cache) {
            return (vue_2.openBlock(), vue_2.createElementBlock("form", {
                class: "submission-form",
                action: "/registration/",
                method: "POST",
                onSubmit: vue_2.withModifiers(submitOrg, ["prevent"])
            }, [
                _hoisted_2,
                vue_2.createElementVNode("div", _hoisted_3, [
                    vue_2.createVNode(InputContainer_vue_1.default, {
                        name: "inn",
                        placeholder: orgForm.value.company_name.placeholder,
                        type: orgForm.value.company_name.type,
                        required: orgForm.value.company_name.required,
                        modelValue: orgForm.value.company_name.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) { return ((orgForm.value.company_name.value) = $event); })
                    }, null, 8, ["placeholder", "type", "required", "modelValue"]),
                    vue_2.createElementVNode("div", _hoisted_4, [
                        vue_2.createVNode(InputContainer_vue_1.default, {
                            name: "inn",
                            placeholder: orgForm.value.inn.placeholder,
                            type: orgForm.value.inn.type,
                            required: orgForm.value.inn.required,
                            modelValue: orgForm.value.inn.value,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) { return ((orgForm.value.inn.value) = $event); })
                        }, null, 8, ["placeholder", "type", "required", "modelValue"]),
                        vue_2.createVNode(InputContainer_vue_1.default, {
                            name: "kpp",
                            placeholder: orgForm.value.kpp.placeholder,
                            type: orgForm.value.kpp.type,
                            required: orgForm.value.kpp.required,
                            modelValue: orgForm.value.kpp.value,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) { return ((orgForm.value.kpp.value) = $event); })
                        }, null, 8, ["placeholder", "type", "required", "modelValue"]),
                        vue_2.createVNode(InputContainer_vue_1.default, {
                            name: "orgn",
                            placeholder: orgForm.value.orgn.placeholder,
                            type: orgForm.value.orgn.type,
                            required: orgForm.value.orgn.required,
                            modelValue: orgForm.value.orgn.value,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) { return ((orgForm.value.orgn.value) = $event); })
                        }, null, 8, ["placeholder", "type", "required", "modelValue"]),
                        vue_2.createVNode(InputContainer_vue_1.default, {
                            name: "bik",
                            placeholder: orgForm.value.bik.placeholder,
                            type: orgForm.value.bik.type,
                            required: orgForm.value.bik.required,
                            modelValue: orgForm.value.bik.value,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) { return ((orgForm.value.bik.value) = $event); })
                        }, null, 8, ["placeholder", "type", "required", "modelValue"]),
                        vue_2.createVNode(InputContainer_vue_1.default, {
                            name: "r_s",
                            placeholder: orgForm.value.r_s.placeholder,
                            type: orgForm.value.r_s.type,
                            required: orgForm.value.r_s.required,
                            modelValue: orgForm.value.r_s.value,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) { return ((orgForm.value.r_s.value) = $event); })
                        }, null, 8, ["placeholder", "type", "required", "modelValue"])
                    ])
                ]),
                vue_2.createElementVNode("div", _hoisted_5, [
                    vue_2.createVNode(Address_vue_1.default, {
                        onUpdate: _cache[6] || (_cache[6] = function ($event) { return (updateFormKey(orgForm.value, { key: 'jur_address', value: $event })); }),
                        title: "Юридический адрес организации"
                    }),
                    vue_2.createElementVNode("label", _hoisted_6, [
                        vue_2.withDirectives(vue_2.createElementVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = function ($event) { return ((checkbox).value = $event); })
                        }, null, 512), [
                            [vue_2.vModelCheckbox, checkbox.value]
                        ]),
                        _hoisted_7,
                        _hoisted_8
                    ])
                ]),
                (checkbox.value)
                    ? (vue_2.openBlock(), vue_2.createBlock(Address_vue_1.default, {
                        key: 0,
                        onUpdate: _cache[8] || (_cache[8] = function ($event) { return (updateFormKey(orgForm.value, { key: 'fac_address', value: $event })); }),
                        title: "Фактический адрес организации"
                    }))
                    : vue_2.createCommentVNode("", true),
                _hoisted_9,
                vue_2.createElementVNode("div", _hoisted_10, [
                    vue_2.createVNode(InputContainer_vue_1.default, {
                        name: "name",
                        placeholder: orgForm.value.name.placeholder,
                        type: orgForm.value.name.type,
                        required: orgForm.value.name.required,
                        modelValue: orgForm.value.name.value,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = function ($event) { return ((orgForm.value.name.value) = $event); })
                    }, null, 8, ["placeholder", "type", "required", "modelValue"]),
                    vue_2.createElementVNode("div", _hoisted_11, [
                        vue_2.createVNode(InputContainer_vue_1.default, {
                            type: "tel",
                            name: "phone",
                            pattern: orgForm.value.phone.pattern,
                            placeholder: orgForm.value.phone.placeholder,
                            required: orgForm.value.phone.required,
                            modelValue: orgForm.value.phone.value,
                            "onUpdate:modelValue": _cache[10] || (_cache[10] = function ($event) { return ((orgForm.value.phone.value) = $event); })
                        }, null, 8, ["pattern", "placeholder", "type", "required", "modelValue"]),
                        vue_2.createVNode(InputContainer_vue_1.default, {
                            name: "email",
                            pattern: orgForm.value.email.pattern,
                            placeholder: orgForm.value.email.placeholder,
                            type: orgForm.value.email.type,
                            required: orgForm.value.email.required,
                            modelValue: orgForm.value.email.value,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = function ($event) { return ((orgForm.value.email.value) = $event); })
                        }, null, 8, ["pattern", "placeholder", "type", "required", "modelValue"])
                    ])
                ]),
                _hoisted_12,
                vue_2.createElementVNode("div", _hoisted_13, [
                    vue_2.createVNode(InputContainer_vue_1.default, {
                        name: "pass",
                        pattern: orgForm.value.pass.pattern,
                        placeholder: orgForm.value.pass.placeholder,
                        type: orgForm.value.pass.type,
                        required: orgForm.value.pass.required,
                        modelValue: orgForm.value.pass.value,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = function ($event) { return ((orgForm.value.pass.value) = $event); })
                    }, null, 8, ["pattern", "placeholder", "type", "required", "modelValue"]),
                    vue_2.createVNode(InputContainer_vue_1.default, {
                        name: "pass2",
                        pattern: orgForm.value.pass2.pattern,
                        placeholder: orgForm.value.pass2.placeholder,
                        type: orgForm.value.pass2.type,
                        required: orgForm.value.pass2.required,
                        modelValue: orgForm.value.pass2.value,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = function ($event) { return ((orgForm.value.pass2.value) = $event); })
                    }, null, 8, ["pattern", "placeholder", "type", "required", "modelValue"])
                ]),
                _hoisted_14,
                vue_2.createElementVNode("div", _hoisted_15, [
                    (vue_2.openBlock(true), vue_2.createElementBlock(vue_2.Fragment, null, vue_2.renderList(formErrors.value, function (error) {
                        return (vue_2.openBlock(), vue_2.createElementBlock("div", null, vue_2.toDisplayString(error), 1));
                    }), 256))
                ])
            ], 40, _hoisted_1));
        };
    }
});
